// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b3dd503c","975":"0a34a8ad"}[chunkId] + ".chunk.js";
};